import { render, staticRenderFns } from "./login-banner.vue?vue&type=template&id=78ccd2a8&scoped=true"
import script from "./login-banner.vue?vue&type=script&lang=js"
export * from "./login-banner.vue?vue&type=script&lang=js"
import style0 from "./login-banner.vue?vue&type=style&index=0&id=78ccd2a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ccd2a8",
  null
  
)

export default component.exports